import { render, staticRenderFns } from "./AutodeskSoftware.vue?vue&type=template&id=2886a12c&scoped=true"
import script from "./AutodeskSoftware.vue?vue&type=script&lang=js"
export * from "./AutodeskSoftware.vue?vue&type=script&lang=js"
import style0 from "./AutodeskSoftware.vue?vue&type=style&index=0&id=2886a12c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2886a12c",
  null
  
)

export default component.exports